import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import OperatorList from 'pages/Operator/OperatorList';
import Icon from 'components/Icon';

const OperatorPage = () => {
  const [searchParams] = useSearchParams();
  const ddd = searchParams.get('ddd') || '';
  const phone = searchParams.get('phone') || '';

  return (
    <div className="operator-page">
      <Link className="back-button" to={`/number?phone=${phone}&ddd=${ddd}`}>
        <Icon icon="chevron-left" width={64} height={64} />
        Voltar
      </Link>
      <OperatorList ddd={ddd} phone={phone} />
    </div>
  );
};

export default OperatorPage;
